import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const translations = {
  fr: {
    // Navigation & General
    nav_serums: "Sérums",
    nav_protocol: "Le Protocole",
    nav_ingredients: "Ingrédients",
    nav_results: "Résultats",
    nav_maison: "La Maison",
    nav_cart: "Panier",
    nav_account: "Compte",
    nav_admin: "Administration",
    nav_login: "Connexion",
    nav_logout: "Déconnexion",
    announcement: "Livraison sécurisée 58 Wilayas · Paiement à la réception",
    all_rights_reserved: "Tous droits réservés.",

    // Hero Section
    hero_badge: "Haute Dermatologie · Formule Pure",
    hero_title_1: "Une peau saine.",
    hero_title_2: "Plus lumineuse.",
    hero_desc: "Conçus à l'intersection de la biologie cutanée et des actifs purs les plus nobles. Une cure dermatologique de sérums ultra-concentrés en Vitamine C et Acide Hyaluronique pour révéler la splendeur naturelle de votre teint.",
    hero_cta_discover: "Découvrir les Sérums",
    hero_cta_routine: "Le Protocole 24h",
    hero_stat_1_val: "15%",
    hero_stat_1_lbl: "Vitamine C Pure",
    hero_stat_2_val: "1 000x",
    hero_stat_2_lbl: "Rétention d'eau",
    hero_stat_3_val: "100%",
    hero_stat_3_lbl: "58 Wilayas",
    hotspot_vitc: "Vitamine C + E",
    hotspot_vitc_sub: "Éclat & Anti-Rides",
    hotspot_hyal: "Acide Hyaluronique",
    hotspot_hyal_sub: "Ultra Hydratation 24h",

    // Brand Story
    story_badge: "Notre Philosophie",
    story_title: "La Pureté de la Nature. La Précision de la Science.",
    story_quote: "« Chaque goutte est une célébration de la science dermatologique. »",
    story_author: "Laboratoires The Queen",
    story_desc_1: "Née d'une vision sans compromis, The Queen élève le soin du visage au rang de rituel royal. Nous refusons les formules diluées et les promesses éphémères. Chacun de nos sérums est formulé avec des concentrations actives maximales, sélectionnées pour leur compatibilité biologique.",
    story_desc_2: "Des flacons protecteurs teintés aux pipettes compte-gouttes de haute précision, chaque détail a été pensé pour préserver la pureté moléculaire de la formule jusqu'au contact de votre peau.",
    story_feat_1: "Actifs 100% Purs",
    story_feat_2: "Efficacité Prouvée",
    story_feat_3: "Tolérance Optimale",
    story_feat_4: "Fabriqué avec Rigueur",

    // Featured Products
    featured_badge: "Haute Efficacité",
    featured_title: "La Collection de Sérums",
    featured_subtitle: "Des formulations concentrées haut de gamme pensées pour agir en parfaite synergie biologique.",
    view_details: "Découvrir la formule",
    add_to_cart: "Ajouter au Panier",
    dzd: "DZD",

    // Routine Section
    routine_badge: "Protocole Quotidien",
    routine_title: "Le Rituel de Beauté Royal",
    routine_subtitle: "L'alternance synergique du Sérum Vitamine C le matin et du Sérum Acide Hyaluronique le soir assure une protection et une régénération cutanée 24h/24.",
    morning_routine: "Rituel Matin — Éclat & Protection",
    evening_routine: "Rituel Soir — Hydratation & Régénération",
    morning_step_1: "Nettoyer délicatement le visage à l'eau tiède.",
    morning_step_2: "Appliquer 4 à 5 gouttes de Sérum Vitamine C Pure sur le visage et le cou.",
    morning_step_3: "Faire pénétrer par légers tapotements stimulants.",
    morning_step_4: "Appliquer votre crème protectrice ou écran solaire habituel.",
    evening_step_1: "Démaquiller et purifier en profondeur l'épiderme.",
    evening_step_2: "Déposer 3 à 4 gouttes de Sérum Acide Hyaluronique sur peau légèrement humide.",
    evening_step_3: "Masser avec des mouvements lissants ascendants.",
    evening_step_4: "Laisser agir toute la nuit pour un réveil à la peau repulpée.",

    // Before & After
    results_badge: "Résultats Cliniques",
    results_title: "Transformation en 28 Jours",
    results_subtitle: "Faites glisser le curseur pour observer l'évolution de la texture de peau après 4 semaines d'utilisation quotidienne du protocole The Queen.",
    before_label: "Jour 0 (Avant)",
    after_label: "Après 28 Jours",
    slider_instruction: "Glissez le curseur pour comparer les résultats cliniques.",
    stat_glow: "+94% Éclat & Luminosité constatés",
    stat_hydration: "+89% Hydratation cutanée continue",
    stat_wrinkles: "-48% Atténuation des ridules",
    adopt_ritual: "Adopter le Rituel",

    // Ingredients
    ingredients_badge: "Biologie Cutanée",
    ingredients_title: "Ingrédients d'Exception",
    ingredients_subtitle: "Des molécules sélectionnées pour leur pureté pharmaceutique et leur affinité naturelle avec la peau.",

    // Benefits
    benefits_badge: "Promesse d'Excellence",
    benefits_title: "Les Bénéfices Scientifiques",

    // Testimonials
    reviews_badge: "Témoignages Vérifiés",
    reviews_title: "Ce qu'en Disent Nos Clientes",

    // Login Page
    login_title: "Connexion Privilège",
    login_subtitle: "Accédez à votre espace client ou tableau de bord CRM The Queen.",
    login_email: "Adresse Email",
    login_password: "Mot de passe",
    login_btn: "Se connecter",
    login_loading: "Connexion en cours...",
    login_no_account: "Pas encore de compte ?",
    login_create_account: "Créer un compte",
    login_admin_quick: "Accès Rapide Admin CRM",
    login_admin_notice: "Identifiants d'administration The Queen",
    login_back_home: "← Retour au site The Queen",

    // Admin CRM
    admin_crm_title: "CRM The Queen — Gestion des Commandes",
    admin_orders: "Commandes",
    admin_revenue: "Chiffre d'Affaires",
    admin_clients: "Clients",
    admin_products: "Produits",
    admin_status_pending: "En attente",
    admin_status_confirmed: "Confirmée",
    admin_status_preparing: "En préparation",
    admin_status_shipped: "Expédiée",
    admin_status_delivered: "Livrée",
    admin_status_cancelled: "Annulée",
    admin_update_status: "Mettre à jour le statut",
    admin_search_placeholder: "Rechercher une commande, client, wilaya...",
    admin_customer_info: "Informations Client",
    admin_delivery_info: "Livraison & Wilaya",
    admin_total: "Total",
  },

  ar: {
    // Navigation & General
    nav_serums: "السيرومات",
    nav_protocol: "البروتوكول",
    nav_ingredients: "المكونات",
    nav_results: "النتائج السريرية",
    nav_maison: "دار كوين",
    nav_cart: "السلة",
    nav_account: "حسابي",
    nav_admin: "لوحة التحكم",
    nav_login: "تسجيل الدخول",
    nav_logout: "تسجيل الخروج",
    announcement: "توصيل سريع ومضمون لكافة الـ 58 ولاية · الدفع عند الاستلام",
    all_rights_reserved: "جميع الحقوق محفوظة.",

    // Hero Section
    hero_badge: "عناية جلدية فائقة الدقة · تركيبة نقية",
    hero_title_1: "بشرة صحية.",
    hero_title_2: "أكثر إشراقاً وتألقاً.",
    hero_desc: "ابتُكرت سيرومات The Queen عند تلاقي علم البيولوجيا الجلدية وأنقى المواد الفعالة. علاج جلدي فائق التركيز بفيتامين C وحمض الهيالورونيك ليكشف عن الإشراقة الملكية الطبيعية لبشرتك.",
    hero_cta_discover: "اكتشفوا السيرومات",
    hero_cta_routine: "بروتوكول 24 ساعة",
    hero_stat_1_val: "15%",
    hero_stat_1_lbl: "فيتامين C نقي",
    hero_stat_2_val: "1 000x",
    hero_stat_2_lbl: "احتباس فائق للماء",
    hero_stat_3_val: "100%",
    hero_stat_3_lbl: "58 ولاية جزائرية",
    hotspot_vitc: "فيتامين C + E",
    hotspot_vitc_sub: "إشراقة ومحاربة التجاعيد",
    hotspot_hyal: "حمض الهيالورونيك",
    hotspot_hyal_sub: "ترطيب مكثف 24 ساعة",

    // Brand Story
    story_badge: "فلسفتنا في العناية",
    story_title: "نقاء الطبيعة مع دقة وصرامة العلم.",
    story_quote: "« كل قطرة هي احتفال بالتميز في علم الجلدية. »",
    story_author: "مخابر The Queen",
    story_desc_1: "انطلاقاً من رؤية لا تقبل المساومة، ترتقي The Queen بالعناية بالبشرة إلى مستوى الطقوس الملكية. نرفض التركيبات المخففة والوعود الزائفة، حيث يُصنع كل سيروم بأعلى التراكيز الفعالة المتوافقة حيوياً مع بشرتك.",
    story_desc_2: "من الزجاجات الداكنة الواقية من الضوء إلى القطارات فائقة الدقة، صُممت كل تفصيلة لحماية نقاء التركيبة الجزيئية حتى ملامستها لبشرتك.",
    story_feat_1: "مواد فعالة 100% نقية",
    story_feat_2: "فعالية مثبتة سريرياً",
    story_feat_3: "تحمل مثالي للبشرة",
    story_feat_4: "صناعة دقيقة وصارمة",

    // Featured Products
    featured_badge: "فعالية استثنائية",
    featured_title: "مجموعة السيرومات الفاخرة",
    featured_subtitle: "تركيبات مركزة فائقة التطور صُممت لتعمل بتناغم حيوي متكامل على بشرتك.",
    view_details: "اكتشفي التركيبة",
    add_to_cart: "أضف إلى السلة",
    dzd: "د.ج",

    // Routine Section
    routine_badge: "البروتوكول اليومي",
    routine_title: "طقس العناية الملكي المزدوج",
    routine_subtitle: "التناغم بين سيروم فيتامين C صباحاً وسيروم حمض الهيالورونيك مساءً يضمن حماية وتجدداً خلوياً عميقاً على مدار 24 ساعة.",
    morning_routine: "طقس الصباح — إشراق وحماية",
    evening_routine: "طقس المساء — ترطيب وتجدد عميق",
    morning_step_1: "تنظيف الوجه بلطف بالماء الفاتر.",
    morning_step_2: "تطبيق 4 إلى 5 قطرات من سيروم فيتامين C النقي على الوجه والرقبة.",
    morning_step_3: "التدليك بحركات دائرية خفيفة لتحفيز الامتصاص.",
    morning_step_4: "وضع الواقي الشمسي أو الكريم المعتاد.",
    evening_step_1: "إزالة المكياج وتنظيف المسام بعمق.",
    evening_step_2: "تطبيق 3 إلى 4 قطرات من سيروم حمض الهيالورونيك على بشرة ندية.",
    evening_step_3: "التدليك بحركات تصاعدية لشد البشرة.",
    evening_step_4: "تركه يعمل طوال الليل للاستيقاظ ببشرة ممتلئة ونضرة.",

    // Before & After
    results_badge: "النتائج السريرية",
    results_title: "التحول الملحوظ في 28 يوماً",
    results_subtitle: "حرّك المؤشر لمشاهدة تحسن نضارة وملمس البشرة بعد 4 أسابيع من الاستخدام اليومي لبروتوكول The Queen.",
    before_label: "اليوم 0 (قبل)",
    after_label: "بعد 28 يوماً",
    slider_instruction: "اسحب المؤشر أفقياً للمقارنة بين النتائج السريرية.",
    stat_glow: "+94% إشراقة ونضارة ملحوظة",
    stat_hydration: "+89% ترطيب مستمر للبشرة",
    stat_wrinkles: "-48% تقليل مظهر التجاعيد والخطوط",
    adopt_ritual: "ابدئي الطقس الآن",

    // Ingredients
    ingredients_badge: "علم خلايا البشرة",
    ingredients_title: "مكونات استثنائية ونقية",
    ingredients_subtitle: "جزيئات مختارة بنقاء صيدلاني لتوافقها الفطري والطبيعي مع خلايا البشرة.",

    // Benefits
    benefits_badge: "عهد التميز",
    benefits_title: "الفوائد العلمية المثبتة",

    // Testimonials
    reviews_badge: "آراء معتمدة",
    reviews_title: "ما تقوله عميلاتنا عن التجربة",

    // Login Page
    login_title: "تسجيل الدخول الراقي",
    login_subtitle: "سجّل دخولك للوصول إلى حسابك أو إلى لوحة إدارة الطلبات CRM.",
    login_email: "البريد الإلكتروني",
    login_password: "كلمة المرور",
    login_btn: "دخول",
    login_loading: "جارٍ تسجيل الدخول...",
    login_no_account: "ليس لديك حساب بعد؟",
    login_create_account: "إنشاء حساب جديد",
    login_admin_quick: "دخول سريع كمسؤول CRM",
    login_admin_notice: "بيانات حساب إدارة The Queen",
    login_back_home: "← العودة إلى الموقع",

    // Admin CRM
    admin_crm_title: "نظام إدارة الطلبات The Queen CRM",
    admin_orders: "الطلبات",
    admin_revenue: "إجمالي المداخيل",
    admin_clients: "العملاء",
    admin_products: "المنتجات",
    admin_status_pending: "قيد الانتظار",
    admin_status_confirmed: "مؤكدة",
    admin_status_preparing: "قيد التحضير",
    admin_status_shipped: "تم الشحن",
    admin_status_delivered: "تم التوصيل",
    admin_status_cancelled: "ملغاة",
    admin_update_status: "تحديث حالة الطلب",
    admin_search_placeholder: "بحث برقم الطلب، اسم العميل، الولاية...",
    admin_customer_info: "بيانات العميل",
    admin_delivery_info: "معلومات التوصيل والولاية",
    admin_total: "المجموع",
  },

  en: {
    // Navigation & General
    nav_serums: "Serums",
    nav_protocol: "The Protocol",
    nav_ingredients: "Ingredients",
    nav_results: "Results",
    nav_maison: "The House",
    nav_cart: "Cart",
    nav_account: "Account",
    nav_admin: "Admin CRM",
    nav_login: "Sign In",
    nav_logout: "Sign Out",
    announcement: "Express delivery across 58 Algerian Wilayas · Cash on Delivery",
    all_rights_reserved: "All rights reserved.",

    // Hero Section
    hero_badge: "Haute Dermatology · Pure Formulation",
    hero_title_1: "Healthy Skin.",
    hero_title_2: "Radiant & Luminous.",
    hero_desc: "Crafted at the intersection of cutaneous biology and pure noble active ingredients. A dermatological treatment of ultra-concentrated Vitamin C and Hyaluronic Acid serums to reveal your skin's natural royal radiance.",
    hero_cta_discover: "Explore Serums",
    hero_cta_routine: "The 24h Protocol",
    hero_stat_1_val: "15%",
    hero_stat_1_lbl: "Pure Vitamin C",
    hero_stat_2_val: "1,000x",
    hero_stat_2_lbl: "Water Retention",
    hero_stat_3_val: "100%",
    hero_stat_3_lbl: "58 Wilayas",
    hotspot_vitc: "Vitamin C + E",
    hotspot_vitc_sub: "Radiance & Anti-Wrinkle",
    hotspot_hyal: "Hyaluronic Acid",
    hotspot_hyal_sub: "24h Ultra-Hydration",

    // Brand Story
    story_badge: "Our Philosophy",
    story_title: "The Purity of Nature. The Precision of Science.",
    story_quote: "“Every drop is a celebration of dermatological science.”",
    story_author: "The Queen Laboratories",
    story_desc_1: "Born from an uncompromising vision, The Queen elevates skincare to a royal ritual. We reject diluted formulas and transient promises. Each of our serums is crafted with maximum active concentrations selected for biological compatibility.",
    story_desc_2: "From tinted protective amber glass bottles to high-precision pipettes, every single detail was engineered to safeguard molecular potency right onto your skin.",
    story_feat_1: "100% Pure Actives",
    story_feat_2: "Clinically Proven",
    story_feat_3: "Optimal Skin Tolerance",
    story_feat_4: "Precision Engineered",

    // Featured Products
    featured_badge: "High Performance",
    featured_title: "The Serum Collection",
    featured_subtitle: "High-concentration formulations engineered to work in biological synergy.",
    view_details: "Discover Formula",
    add_to_cart: "Add to Cart",
    dzd: "DZD",

    // Routine Section
    routine_badge: "Daily Protocol",
    routine_title: "The Royal Beauty Ritual",
    routine_subtitle: "Synergistic alternation of Vitamin C in the morning and Hyaluronic Acid at night provides 24-hour continuous cellular hydration and protection.",
    morning_routine: "Morning Ritual — Radiance & Defense",
    evening_routine: "Evening Ritual — Hydration & Renewal",
    morning_step_1: "Cleanse skin gently with lukewarm water.",
    morning_step_2: "Apply 4 to 5 drops of Pure Vitamin C Serum to face and neck.",
    morning_step_3: "Gently press in with upward circular motions.",
    morning_step_4: "Follow with your daily sunscreen or moisturizer.",
    evening_step_1: "Thoroughly cleanse and prep the skin.",
    evening_step_2: "Dispense 3 to 4 drops of Hyaluronic Acid Serum onto damp skin.",
    evening_step_3: "Massage gently with upward lifting strokes.",
    evening_step_4: "Allow overnight absorption for plump, glowing skin upon waking.",

    // Before & After
    results_badge: "Clinical Results",
    results_title: "28-Day Visible Transformation",
    results_subtitle: "Slide the cursor to observe the refinement in skin tone and texture after 4 weeks of daily use.",
    before_label: "Day 0 (Before)",
    after_label: "After 28 Days",
    slider_instruction: "Drag the slider to compare clinical results.",
    stat_glow: "+94% Measured Radiance & Glow",
    stat_hydration: "+89% Continuous Deep Hydration",
    stat_wrinkles: "-48% Reduction in Fine Lines",
    adopt_ritual: "Adopt the Ritual",

    // Ingredients
    ingredients_badge: "Skin Biology",
    ingredients_title: "Exceptional Active Ingredients",
    ingredients_subtitle: "Molecules selected for their pharmaceutical purity and natural biocompatibility with human skin cells.",

    // Benefits
    benefits_badge: "Promise of Excellence",
    benefits_title: "Scientifically Proven Benefits",

    // Testimonials
    reviews_badge: "Verified Testimonials",
    reviews_title: "What Our Clients Say",

    // Login Page
    login_title: "Privileged Access",
    login_subtitle: "Sign in to your client account or access The Queen CRM dashboard.",
    login_email: "Email Address",
    login_password: "Password",
    login_btn: "Sign In",
    login_loading: "Signing in...",
    login_no_account: "Don't have an account yet?",
    login_create_account: "Create an Account",
    login_admin_quick: "Quick Admin CRM Sign In",
    login_admin_notice: "The Queen Administrator Credentials",
    login_back_home: "← Back to Store",

    // Admin CRM
    admin_crm_title: "The Queen CRM — Order Management System",
    admin_orders: "Orders",
    admin_revenue: "Total Revenue",
    admin_clients: "Clients",
    admin_products: "Products",
    admin_status_pending: "Pending",
    admin_status_confirmed: "Confirmed",
    admin_status_preparing: "Preparing",
    admin_status_shipped: "Shipped",
    admin_status_delivered: "Delivered",
    admin_status_cancelled: "Cancelled",
    admin_update_status: "Update Status",
    admin_search_placeholder: "Search by order #, customer, wilaya...",
    admin_customer_info: "Customer Information",
    admin_delivery_info: "Delivery & Wilaya",
    admin_total: "Total",
  }
};

export function LanguageProvider({ children }) {
  // Default language is French ('fr')
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("thequeen_lang") || "fr";
  });

  useEffect(() => {
    localStorage.setItem("thequeen_lang", lang);
    // Apply RTL for Arabic
    if (lang === "ar") {
      document.documentElement.dir = "rtl";
      document.documentElement.lang = "ar";
    } else {
      document.documentElement.dir = "ltr";
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = (key) => {
    return translations[lang]?.[key] || translations["fr"]?.[key] || key;
  };

  const isRTL = lang === "ar";

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
